const parseSelector = (selector) => {
	if (selector && CSS && CSS.escape) {
		// document.querySelector needs escaping to handle IDs (html5+) containing for instance /
		selector = selector.replace(/#([^\s"#']+)/g, (match, id) => `#${CSS.escape(id)}`);
	}

	return selector;
};

const isElement = (object) => {
	if (!object || typeof object !== 'object') {
		return false;
	}

	return typeof object.nodeType !== 'undefined';
};

const getElement = (object) => {
	if (isElement(object)) {
		return object;
	}

	if (typeof object === 'string' && object.length > 0) {
		return document.querySelector(parseSelector(object));
	}

	return null;
};

export { parseSelector, isElement, getElement };
